import { DroppedImage } from "@lib/store/src/mark";
import { CommentModal } from "../modals/mark-modal-comment";
import { markStore } from "@lib/store/src/mark";
import { checkForOverlaps, getStoreByControlId } from "./image-tools";
import { runInAction } from "mobx";
import { detachImageConnection, removeConnectionLineForce, unhighlightTarget } from "./event-handlers";
import i18next from "i18next";

let activeMenu: HTMLDivElement | null = null;

export function showContextMenu(img: HTMLImageElement, imgData: DroppedImage, x: number, y: number) {
  if (activeMenu) activeMenu.remove();
  const menu = document.createElement("div");
  menu.style.position = "absolute";
  
  menu.style.background = "#fff";
  menu.style.border = "1px solid #ccc";
  menu.style.padding = "4px 0";
  menu.style.zIndex = "999999999999";
  menu.style.minWidth = "160px";
  menu.style.boxShadow = "0 2px 5px rgba(0,0,0,0.2)";
  menu.style.fontFamily = "sans-serif";
  document.body.appendChild(menu);
  const option = (label: string, handler: () => void) => {
    const item = document.createElement("div");
    item.textContent = label;
    item.style.padding = "6px 12px";
    item.style.cursor = "pointer";
    item.onmouseenter = () => (item.style.background = "#eee");
    item.onmouseleave = () => (item.style.background = "#fff");
    item.onclick = () => {
      handler();
      menu.remove();
    };
    return item;
  };
  const storeDelete = getStoreByControlId(imgData.controlId)
  const realImgDelete = storeDelete?.droppedImages.find(i => i.id === imgData.id);
  let titleLabelDel;

  if (realImgDelete?.origin === "poster") {
    titleLabelDel = i18next.t("delposter");
  } else if (realImgDelete?.origin === "mark") {
    titleLabelDel = i18next.t("delmark");
  }
  
  menu.appendChild(option(`${i18next.t("dictionary_toolbar_delete")} ${titleLabelDel}`, () => {
    if(realImg?.linkedElementId) detachImageConnection(realImg);
    if(store) {
      runInAction(() => {
        store.removeImage(imgData)
      })
    }
    const wrapper = img.closest(".image-container");
    if (wrapper) wrapper.remove();
    img.remove()
  }));

  const currentComment = imgData.comment ?? "";
  const commentLabel = currentComment.trim()
      ? `${i18next.t("edit_comment")}`
      : `${i18next.t("add_comment")}`;
  
  menu.appendChild(option(commentLabel, () => {
    const store = getStoreByControlId(imgData.controlId);
    const realImg = store?.droppedImages.find(i => i.id === imgData.id);
    let titleLabel = `${i18next.t("mark_user_comment")}`;

    if (realImg?.origin === "poster") {
      titleLabel = `${i18next.t("poster")}`;
    } else if (realImg?.origin === "mark") {
      titleLabel = `${i18next.t("mark")}`;
    }
    const user = $sw.serverState.UserData.user;
    new CommentModal(
      img.src,
      titleLabel,
      currentComment,
      imgData,
      user
    )
  }));

  const unlinkItem = document.createElement("div");
  unlinkItem.textContent = `${i18next.t("break_connection")}`;
  unlinkItem.style.padding = "6px 12px";
  const store = getStoreByControlId(imgData.controlId);
  const realImg = store?.droppedImages.find(i => i.id === imgData.id);
  const hasLink = realImg?.linkedElementId ? true : false;

  unlinkItem.style.cursor = hasLink ? "pointer" : "not-allowed";
  unlinkItem.style.opacity = hasLink ? "1" : "0.4";

  unlinkItem.onmouseenter = () => {
    if (hasLink) unlinkItem.style.background = "#eee";
  };

  unlinkItem.onclick = () => {
    if (!hasLink) return;
    detachImageConnection(realImg!);
    const store = getStoreByControlId(imgData.controlId);
    if (!store) return;
    const oldLinkedId = realImg!.linkedElementId;

    runInAction(() => {
      realImg!.linkedElementId = null;
      realImg!.linkSide = null;
      realImg!.targetSide = null;
      imgData.linkedElementId = null;
      imgData.linkSide = null;
      imgData.targetSide = null;
      
      store.droppedImages = [...store.droppedImages];
    });
    const imgEl = document.querySelector(`img[data-id="${realImg!.id}"]`);
    if (imgEl) {
      removeConnectionLineForce(imgEl);
    }
    if (oldLinkedId) {
      const targetEl = document.getElementById(oldLinkedId);
      if (targetEl) unhighlightTarget(targetEl);
    }
    checkForOverlaps(realImg!);
    menu.remove();
  };
  menu.appendChild(unlinkItem);
  menu.style.left = `${x}px`;
  menu.style.top = `${y}px`;
  const rect = menu.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  if (rect.bottom > viewportHeight) {
    const newTop = viewportHeight - rect.height - 50; 
    menu.style.top = `${Math.max(10, newTop)}px`;
  }
  if (rect.right > viewportWidth) {
    const newLeft = viewportWidth - rect.width - 10;
    menu.style.left = `${Math.max(10, newLeft)}px`;
  }

  activeMenu = menu;
  const closeHandler = (ev: MouseEvent) => {
    const target = ev.target as HTMLElement;
    if (menu.contains(target)) return;
    menu.remove();
    activeMenu = null;
    document.removeEventListener("mousedown", closeHandler);
  };
  document.addEventListener("mousedown", closeHandler);
  return menu;
}

export function showGroupContextMenu(e: MouseEvent, groupId: string) {
  e.preventDefault();
  e.stopPropagation();
  document.querySelectorAll(".mark-context-menu").forEach(el => el.remove());

  const menu = document.createElement("div");
  menu.className = "mark-context-menu";
  
  Object.assign(menu.style, {
    position: "absolute",
    left: `${e.clientX}px`,
    top: `${e.clientY}px`,
    zIndex: "99999999999",
  });

  const groupImages = Array.from(document.querySelectorAll(`img[data-group="${groupId}"]`)) as HTMLImageElement[];
  if (!groupImages.length) return;
  const makeOption = (label: string) => {
    const item = document.createElement("div");
    item.className = "mark-context-menu-item";
    item.style.display = "flex";
    item.style.justifyContent = "space-between";
    item.style.alignItems = "center";

    const text = document.createElement("span");
    text.textContent = label;

    const arrow = document.createElement("span");
    arrow.textContent = "➤"; 
    arrow.style.opacity = "0.6";
    arrow.style.fontSize = "12px";
    arrow.style.marginLeft = "8px";

    item.appendChild(text);
    item.appendChild(arrow);
    return item;
  };

  groupImages.forEach((img) => {
    const id = img.dataset.id;
    const container = img.closest(".image-container") as HTMLElement;
    const controlId = container?.dataset.controlId;    
    const store = getStoreByControlId(controlId);
    const imgData = store?.droppedImages.find(i => i.id === id);

    const mark = imgData ? markStore.findMarkBySrc(imgData.src) : null;
    const label = mark?.name || imgData?.propertysubtypes || img.getAttribute("alt") || `Метка ${id}`;
    const row = makeOption(label);
    menu.appendChild(row);

    row.addEventListener("mousedown", (ev) => {
      ev.stopPropagation();
    })

    row.addEventListener("mouseenter", () => {
      const rect = row.getBoundingClientRect();
      const x = rect.right;
      const y = rect.top;

      const subMenu = showContextMenu(img, imgData, x, y);
      if (!subMenu) return;

      requestAnimationFrame(() => {
        const vw = window.innerWidth;
        const subRect = subMenu.getBoundingClientRect();
        if (subRect.right > vw) {
          const leftToOpen = rect.left - subRect.width;
          subMenu.style.left = `${Math.max(10, leftToOpen)}px`;
        }
        const subRect2 = subMenu.getBoundingClientRect();
        if (subRect2.left < 0) {
          subMenu.style.left = `150px`;
        }
      });
      menu.dataset.locked = "1";
      subMenu.addEventListener("mouseenter", () => {
        menu.dataset.locked = "1";
      });

      subMenu.addEventListener("mouseleave", () => {
        const hovered = document.querySelector(":hover") as HTMLElement | null;
        const stillOverMain = hovered && menu.contains(hovered);
        if (stillOverMain) return;
        
        subMenu.remove();
        menu.dataset.locked = "0";
      });
      const closeOnClickOutside = (ev: MouseEvent) => {
        const target = ev.target as HTMLElement;
        const outsideMain = !menu.contains(target);
        const outsideSub = !subMenu.contains(target);

        if (outsideMain && outsideSub) {
          subMenu.remove();
          menu.remove();
          document.removeEventListener("mousedown", closeOnClickOutside);
        }
      };
    document.addEventListener("mousedown", closeOnClickOutside);
    });
  });
  document.body.appendChild(menu);
  const rect = menu.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  if (rect.bottom > viewportHeight) {
    const newTop = viewportHeight - rect.height - 70; 
    menu.style.top = `${Math.max(10, newTop)}px`;
  }
  if (rect.right > viewportWidth) {       
    const newLeft = viewportWidth - rect.width - 10;
    menu.style.left = `${Math.max(10, newLeft)}px`;
  }
  const close = (ev: MouseEvent) => {
    if (!menu.contains(ev.target as Node)) {
      const target = ev.target as HTMLElement;
      if (menu.contains(target)) return;
      const submenu = document.querySelector(".mark-context-menu.sub");
      if (submenu && submenu.contains(target)) return;
      menu.remove();
      document.querySelectorAll(".mark-context-menu").forEach(el => el.remove());
      document.removeEventListener("mousedown", close);
    }
  };
    document.addEventListener("mousedown", close);
}
